/**
 * The drawer entry's link text: "Play Demo", "Learn more" or "Take me there".
 * The feed doesn't name the customer's community or report, so the link doesn't either. The entry
 * draws the arrow (or the play icon); a message with no action has no link.
 */
const getNotificationEntryLinkLabel = ({ cta }) => {
    switch (cta === null || cta === void 0 ? void 0 : cta.variant) {
        case undefined:
            return undefined;
        case "watch_demo":
            return "Play Demo";
        case "learn_more":
            return "Learn more";
        default:
            return "Take me there";
    }
};

export { getNotificationEntryLinkLabel };
